import { Box } from '@chakra-ui/react';
import {
  Avatar,
  AvatarImage,
  ListItemComp,
  ListItemCompContent,
  ListItemCompLeading,
  ListItemCompTitle,
} from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { TABLE_COLUMNS_DISPLAYNAME } from '../constant';
import { getDaysAgo } from './utils';

export const getCellValue = (columnName: keyof typeof TABLE_COLUMNS_DISPLAYNAME, cellData) => {
  switch (columnName) {
    case TABLE_COLUMNS_DISPLAYNAME.REVIEWEE_NAME: {
      return cellData?.employee?.displayName ?? '';
    }

    case TABLE_COLUMNS_DISPLAYNAME.ACTION_ITEMS: {
      const completedActionItemCount = cellData?.completedActionItemCount ?? 0;
      const totalActionItemCount = cellData?.totalActionItemCount ?? 0;
      if (!completedActionItemCount && !totalActionItemCount) return 'No action plan added';
      return `${completedActionItemCount}/${totalActionItemCount} completed`;
    }

    case TABLE_COLUMNS_DISPLAYNAME.LAST_ACTIVITY: {
      const { lastActivityTime } = cellData;
      const dateDaysAgo = getDaysAgo(lastActivityTime);
      return dateDaysAgo;
    }

    default: {
      return new Error('Invalid column name');
    }
  }
};

const getCellContent = (columnName: keyof typeof TABLE_COLUMNS_DISPLAYNAME, cellData) => {
  switch (columnName) {
    case TABLE_COLUMNS_DISPLAYNAME.REVIEWEE_NAME: {
      const employeeName = getCellValue(columnName, cellData);
      const profilePhoto = cellData?.employee?.profilePhoto;

      return (
        <Box className="info">
          <ListItemComp style={{ padding: 0 }}>
            <ListItemCompLeading>
              <Avatar>
                <AvatarImage src={profilePhoto} alt={`Profile picture of ${employeeName}`} />
              </Avatar>
            </ListItemCompLeading>
            <ListItemCompContent>
              <ListItemCompTitle bold={false}>{employeeName}</ListItemCompTitle>
            </ListItemCompContent>
          </ListItemComp>
        </Box>
      );
    }

    case TABLE_COLUMNS_DISPLAYNAME.ACTION_ITEMS: {
      const actionItemCompletedText = getCellValue(columnName, cellData);

      return (
        <Box className="info">
          <TextBodyMedium>{actionItemCompletedText}</TextBodyMedium>
        </Box>
      );
    }

    case TABLE_COLUMNS_DISPLAYNAME.LAST_ACTIVITY: {
      const lastActivityText = getCellValue(columnName, cellData);

      return (
        <Box className="info">
          <TextBodyMedium>{lastActivityText}</TextBodyMedium>
        </Box>
      );
    }

    default:
      return new Error('Invalid column name');
  }
};

export const PlanOfActionCellRenderer = (params) => {
  const cellInfo = params.colDef;
  const { displayName } = cellInfo;
  const cellData = params.data;
  return getCellContent(displayName, cellData);
};
